import { AboutUsData } from '../../providers/about-us-data';
import { Component } from '@angular/core';
import { UserData } from '../../../../providers/user-data';
import { Events, LoadingController, NavController, NavParams } from 'ionic-angular';
import { PageBaseFull } from '../../../../core/page-base.full';
import { AppSettings } from '../../../../config/app-settings';
import { AboutUsCommon } from './about-us.common';
import { Storage } from '@ionic/storage';
import { AngularFireDatabaseWrapper } from '../../../../providers/angularfire-wrapper';



@Component({
	selector: 'page-about-us-full',
	templateUrl: 'about-us.full.html'
})
export class AboutUsPageFull extends PageBaseFull {
	public recipesList: any;
	public recipeCategories: any;
	public loader: any;
	public userRecipes = [];
	public localUserRecipes = [];
	public localUserRecipeKeys = {};
	public recipeBoxData: any;
	public userId = '';
	public categoryUrlSlug = 'all';
	public category = {};
	constructor(
		public nav: NavController,
		public userData: UserData,
		public settings: AppSettings,
		public common: AboutUsCommon,
		public events: Events,
		public storage: Storage,
		public afw: AngularFireDatabaseWrapper,
		public loadingCtrl: LoadingController,
		public aboutUsData: AboutUsData,
		private navParams: NavParams
	) {
		super(settings, events, nav, userData);
		this.loader = this.loadingCtrl.create();
		this.categoryUrlSlug = navParams.get('categoryUrlSlug');

	}
	ngAfterViewInit() {
		//this.common.commonMethod();
	}

	ionViewDidEnter() {
	}
	
}



// WEBPACK FOOTER //
// ./src/modules/about-us/pages/about-us/about-us.full.ts